import {
  VOICE_SET_INCOMING_CALL,
  VOICE_SET_ACTIVE_CALL,
  VOICE_CLEAR_INCOMING_CALL,
  VOICE_CLEAR_ACTIVE_CALL,
  VOICE_SET_CURRENT_CALL_CONTROL_ID,
  VOICE_SET_CONNECTED,
  VOICE_SET_MUTED,
  VOICE_SET_RINGING,
  VOICE_SET_LOADING,
  VOICE_SET_ERROR,
  VOICE_RESET_CALL_STATE,
  VOICE_ADD_INCOMING_CALL,
  VOICE_REMOVE_INCOMING_CALL,
  VOICE_SET_SOCKET_CONNECTED,
  VOICE_SET_OUTBOUND_DIALING,
  VOICE_CLEAR_OUTBOUND_DIALING,
  VOICE_RELEASE_CALL_SESSION
} from '../../actions/voice/voiceActions';

/** @type {import('../../presentation/hooks/voice/domain/voiceTypes').VoiceState} */
const initialState = {
  incomingCall: null,
  incomingCalls: [],
  activeCall: null,
  outboundDialingCall: null,
  currentCallControlId: null,
  isConnected: false,
  isSocketConnected: false,
  isMuted: false,
  isRinging: false,
  loading: false,
  error: null
};

function syncIncomingCallFromQueue(incomingCalls) {
  return incomingCalls.length > 0 ? incomingCalls[0] : null;
}

function thisTabCallControlId(state, endedId) {
  if (state.activeCall?.callControlId && state.activeCall.callControlId !== endedId) {
    return state.activeCall.callControlId;
  }
  if (
    state.outboundDialingCall?.callControlId
    && state.outboundDialingCall.callControlId !== endedId
  ) {
    return state.outboundDialingCall.callControlId;
  }
  if (state.currentCallControlId && state.currentCallControlId !== endedId) {
    return state.currentCallControlId;
  }
  return null;
}

export default function voiceReducer(state = initialState, action) {
  switch (action.type) {
    case VOICE_ADD_INCOMING_CALL: {
      const exists = state.incomingCalls.some(
        (call) => call.callControlId === action.payload?.callControlId
      );
      if (exists) {
        return state;
      }
      const incomingCalls = [...state.incomingCalls, action.payload];
      return {
        ...state,
        incomingCalls,
        incomingCall: syncIncomingCallFromQueue(incomingCalls),
        isRinging: true,
        error: null
      };
    }
    case VOICE_REMOVE_INCOMING_CALL: {
      const removedId = action.payload;
      const incomingCalls = state.incomingCalls.filter(
        (call) => call.callControlId !== removedId
      );

      return {
        ...state,
        incomingCalls,
        incomingCall: syncIncomingCallFromQueue(incomingCalls),
        currentCallControlId: thisTabCallControlId(state, removedId),
        isRinging: incomingCalls.length > 0
      };
    }
    case VOICE_SET_INCOMING_CALL: {
      const incomingCalls = state.incomingCalls.some(
        (call) => call.callControlId === action.payload?.callControlId
      )
        ? state.incomingCalls
        : [...state.incomingCalls, action.payload];
      return {
        ...state,
        incomingCall: action.payload,
        incomingCalls,
        isRinging: true,
        error: null
      };
    }
    case VOICE_SET_ACTIVE_CALL: {
      const activeId = action.payload?.callControlId;
      const incomingCalls = state.incomingCalls.filter(
        (call) => call.callControlId !== activeId
      );
      return {
        ...state,
        activeCall: action.payload,
        outboundDialingCall: null,
        incomingCalls,
        incomingCall: syncIncomingCallFromQueue(incomingCalls),
        currentCallControlId: activeId ?? state.currentCallControlId,
        isRinging: incomingCalls.length > 0,
        error: null
      };
    }
    case VOICE_SET_OUTBOUND_DIALING:
      return {
        ...state,
        outboundDialingCall: action.payload,
        activeCall: null,
        currentCallControlId: action.payload?.callControlId ?? state.currentCallControlId,
        isRinging: true,
        error: null
      };
    case VOICE_CLEAR_OUTBOUND_DIALING:
      return {
        ...state,
        outboundDialingCall: null,
        isRinging: state.incomingCalls.length > 0
      };
    case VOICE_CLEAR_INCOMING_CALL:
      return {
        ...state,
        incomingCall: null,
        incomingCalls: [],
        isRinging: false
      };
    case VOICE_CLEAR_ACTIVE_CALL:
      return {
        ...state,
        activeCall: null,
        outboundDialingCall: null,
        currentCallControlId: null,
        isMuted: false,
        isRinging: state.incomingCalls.length > 0,
        loading: false
      };
    case VOICE_RELEASE_CALL_SESSION: {
      const endedId = action.payload;
      const incomingCalls = state.incomingCalls.filter(
        (call) => call.callControlId !== endedId
      );
      const endedActive = state.activeCall?.callControlId === endedId;
      const endedOutbound = state.outboundDialingCall?.callControlId === endedId;
      return {
        ...state,
        incomingCalls,
        incomingCall: syncIncomingCallFromQueue(incomingCalls),
        activeCall: endedActive ? null : state.activeCall,
        outboundDialingCall: endedOutbound ? null : state.outboundDialingCall,
        currentCallControlId: thisTabCallControlId(state, endedId),
        isMuted: endedActive ? false : state.isMuted,
        isRinging: incomingCalls.length > 0,
        loading: false,
        error: null
      };
    }
    case VOICE_SET_CURRENT_CALL_CONTROL_ID:
      return {
        ...state,
        currentCallControlId: action.payload
      };
    case VOICE_SET_CONNECTED:
      return {
        ...state,
        isConnected: action.payload
      };
    case VOICE_SET_MUTED:
      return {
        ...state,
        isMuted: action.payload
      };
    case VOICE_SET_RINGING:
      return {
        ...state,
        isRinging: action.payload
      };
    case VOICE_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case VOICE_SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case VOICE_SET_SOCKET_CONNECTED:
      return {
        ...state,
        isSocketConnected: action.payload
      };
    case VOICE_RESET_CALL_STATE:
      return {
        ...initialState,
        isConnected: state.isConnected,
        isSocketConnected: state.isSocketConnected
      };
    default:
      return state;
  }
}
